import React, { useContext, useEffect, useMemo, useState } from "react";
import ReusableBreadcrumbs from "../../../CommonComponents/ReusableBreadCrumbs";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Stepper from "../../../CommonComponents/Stepper";
import constants, { RESULT_STATUS } from "../../../../constants";
import { nanoid } from "nanoid";
import QuestionForm from "./QuestionForm";
import QuestionConfiguration from "./QuestionConfiguration";
import QuestionValidation from "./QuestionValidation";
import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import AlertContext from "../../../../context/AlertContext";
import { LibraryContext } from "../../../../context/LibraryContext";
import useAddOrUpdateLp from "../../../../Hooks/useApiCall";
import { getDataFromStorage } from "../../../../util";
import Loading from "../../../Notification-Loading/Loading/Loading";
import Modal from "../../../CommonComponents/Modal";
import Button from "../../../Button";
import Toast from "../../../CommonComponents/Toast";
import Banner from "./Banner";

const initialValue = {
  title: "",
  name: "",
  description: "",
  answer: "",
  duration: "",
  marks: "",
  returntype: {},
  functionname: "",
  enableNoteBook: 0,
  secName: [{ topics: "", level: "" }],
  functionparams: [
    {
      id: nanoid(),
      parametername: "",
      parametertype: "",
    },
  ],
  testcases: [
    {
      actualoutput: "",
      id: nanoid(),
      input: "",
      isExample: 0,
      output: "",
      isActive: true,
    },
    {
      actualoutput: "",
      id: nanoid(),
      input: "",
      isExample: 0,
      output: "",
      isActive: false,
    },
    {
      actualoutput: "",
      id: nanoid(),
      input: "",
      isExample: 0,
      output: "",
      isActive: false,
    },
  ],
  ccTopic: "",
  ccLevel: "",
  autoevaluate: 1,
  evaluationrule: [],
  supportedLanguage: [
    {
      id: 1,
      name: "Java",
      isActive: true,
      allTestCasesPassed: false,
      boilerplate: "",
      solution: "",
    },
  ],
};

const validators = {
  0: {
    title: (v) => (v?.length >= 100 ? "Max characters: 100" : ""),
    name: (v) =>
      !v?.trim()
        ? "Name is required"
        : v?.length >= 100
        ? "Max characters: 100"
        : "",
    secName: {
      topics: (v) => (!v ? "Topic is required" : ""),
      level: (v) => (!v ? "Complexity is required" : ""),
    },
    ccSecName: {
      ccTopic: (v) => (!v ? "Topic is required" : ""),
      ccLevel: (v) => (!v ? "Complexity is required" : ""),
    },
    topicComplexity: (value) => {
      if (!value || value.length === 0) {
        return "At least one topic and complexity must be selected";
      } else {
        for (let i = 0; i < value.length; i++) {
          if (!value[i].topicId || !value[i].complexityId) {
            return "Both topic and complexity are required for each entry";
          }
        }
      }
      return null;
    },
  },

  1: {
    marks: (v) => (!v || !+v || +v <= 0 ? "Invalid mark" : ""),
    // duration: (v) => (!v || !+v || +v <= 0 ? "Invalid duration" : ""),
    returntype: (v) => (!v ? "Return type is required" : ""),
    functionname: (v) => {
      if (!v || +v) {
        return "Invalid function name";
      } else if (v.split(" ").length > 1) {
        return "Spaces are not allowed";
      } else {
        return "";
      }
    },
    functionparams: {
      parametername: (v) => {
        if (!v) {
          return "Parameter name is required";
        } else if (+v) {
          return "Parameter name must start with a string";
        } else if (v.length > 25) {
          return "Max char is 25";
        } else {
          return "";
        }
      },
      parametertype: (v) => (!v ? "Parameter type is required" : ""),
    },
    // testcases: {
    //   input: (input = "", paramCount) => {
    //     // console.log("input:",input);

    //     const errors = Array(paramCount).fill(null);
    //     const values = typeof input === "string" ? input.split("\n") : [];

    //     // console.log('values',values);

    //     for (let i = 0; i < paramCount; i++) {
    //       const trimmedValue = values[i]?.trim();
    //       if (!trimmedValue || trimmedValue.length === 0) {
    //         errors[i] = "Input is required";
    //       }
    //     }

    //     return errors.every((e) => e === null) ? null : errors;
    //   },

    //   output: (v) => (!v ? "output is required" : ""),
    //   // isexample:()
    // },
  },

  2: {
    viewTest: (v) =>
      v === null || v === undefined ? "Select student view" : "",
  },
};
const CodingQuestionEntry = (Props) => {
  const { type, questionid } = useParams();
  const [searchParams] = useSearchParams();
  const isFixedQns = searchParams.get("fixedqns");
  const useCommonFunctionHks = useCommonFunctionHooks();
  const { handleAddOrUpdateLp } = useAddOrUpdateLp();
  const LibraryCxt = useContext(LibraryContext);
  const Alert = useContext(AlertContext);
  const { setShowNotify, isqueReport } = useContext(AlertContext);
  const axios = useAxiosPrivate();
  const navigate = useNavigate();
  const [testDetails, setTestDetails] = useState(initialValue);
  const [libTypeId, setLibTypeId] = useState(null);
  const [errors, setErrors] = useState({
    0: {},
    1: {
      sections: "",
      topics: {},
      section: {},
    },
    2: {},
  });

  const [toastType, setToastType] = useState("warning");
  const [openToast, setOpenToast] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  let [qcodes, setQcodes] = useState([]);
  const [embedLinksList, setEmbedLinksList] = useState(
    Alert.isqueReport ? Props.selectque.embedlinks : [],
  );

  const [topicErrors, setTopicErrors] = useState({});
  const isPublished =
    searchParams.get("published") === 1 ||
    searchParams.get("published") === "1";
  const [activeStep, setActiveStep] = useState(0);
  const [isButtonDisable, setIsButtonDisable] = useState(false);
  //page 1
  const [level, setLevel] = useState([]);
  const [topics, setTopics] = useState([]);
  const [ccTopic, setCcTopic] = useState([]);
  const [selectedTopics, setSelectedTopics] = useState([]);
  //page 2
  const returnTypes = [
    { value: "int", label: "Int" },
    { value: "float", label: "Float" },
    { value: "double", label: "Double" },
    { value: "string", label: "String" },
    { value: "char", label: "Char" },
    { value: "boolean", label: "Boolean" },
    { value: "array-1int", label: "Array 1D Number" },
    { value: "array-2int", label: "Array 2D Number" },
    { value: "array-1string", label: "Array 1D String" },
    { value: "array-2string", label: "Array 2D String" },
    { value: "array-1float", label: "Array 1D Float" },
    { value: "array-2float", label: "Array 2D Float" },
    { value: "treenode", label: "TreeNode" },
    { value: "listnode", label: "ListNode" },
    { value: "void", label: "New File" },
    { value: "void", label: "File Void" },
    { value: "void", label: "Same File" },
    // { value: "array-1char", label: "Array 1D Char" },
    // { value: "array-2char", label: "Array 2D Char" },
  ];

  const [currentType, setCurrentType] = useState({});
  const [parameters, setParameters] = useState([
    {
      id: nanoid(),
      parametername: "",
      parametertype: "",
      isdeletable: false,
    },
  ]);
  // const [currParameter, setCurrParameter] = useState([]);
  // const [count, setCount] = useState(1);
  const [value, setValue] = useState(0);
  const [testcases, setTestCases] = useState(initialValue.testcases);
  //Page 3
  const [languages, setLanguages] = useState([]);
  const [selectedCodingLanguages, setSelectedCodingLanguages] = useState(
    initialValue.supportedLanguage,
  );
  const [validationRules, setValidationRules] = useState([]);
  const [selectedLaguage, setSelectedLanguage] = useState(0); //for tabs
  const [languagesOfPassedTestCases, setLanguagesOfPassedTestCases] = useState(
    [],
  );
  const [fromEditQuestion, setFromEditQuestion] = useState(false);
  const [languageKeys, setLanguageKeys] = useState([]);
  const [dataIsLoading, setDataIsLoading] = useState(false);
  const [showPopupForm, setShowPopupForm] = useState(false);

  //edit scenario
  useEffect(() => {
    const fetchTopicsComplexity = async () => {
      try {
        const [topics, complexity] = await Promise.all([
          axios.get("node/admin/topic/get/0"),
          axios.get("node/admin/complexity/get"),
        ]);
        let editTopics = [];
        if (topics.data.resultCode === RESULT_STATUS.SUCCESS) {
          editTopics = topics.data?.data?.map((topic) => ({
            value: topic.id,
            label: topic.name,
          }));
          setTopics(
            topics.data?.data?.map((topic) => ({
              value: topic.id,
              label: topic.name,
            })),
          );
        }
        let editComplexity = complexity.data?.map((comp) => ({
          value: comp.id,
          label: comp.name,
        }));
        setLevel(
          complexity.data?.map((comp) => ({
            value: comp.id,
            label: comp.name,
          })),
        );
        return { editTopics, editComplexity };
      } catch (error) {
        console.error("Error fetching topics and complexity:", error);
      }
    };

    const fetchEvaluationRule = async () => {
      try {
        const response = await axios.get(
          "node/admin/evalrules/get",
          useCommonFunctionHks.getHeaderDetailsForAxios(),
        );
        // console.log("respponse:", response);

        let json = response.data;
        let evalRules = json.map((rule) => {
          return {
            value: rule.id,
            label: rule.name,
          };
        });

        setValidationRules(evalRules);
        return evalRules;
      } catch (error) {
        console.error("Error in Evaluation rules:", error);
      }
    };

    const getQuestionDetails = async () => {
      try {
        setDataIsLoading(true);
        if (getDataFromStorage("role") === constants.Roles.tutor)
          Alert.setPreview(true);
        const endpoint = `node/admin/question/${questionid}`;

        // console.log("endPoint:", endpoint);

        const response = await axios.get(
          endpoint,
          useCommonFunctionHks.getHeaderDetailsForAxios(),
        );

        let json = response.data;
        let newData;
        newData = JSON.parse(json[0].data);
        newData.type = parseInt(type);

        // console.log("questionId:", questionid);

        newData.qnId = questionid;
        newData.published = 0;

        console.log("newData:", newData);

        const { editTopics, editComplexity } = await fetchTopicsComplexity();
        const evalRules = await fetchEvaluationRule();
        //topicCompexity
        console.log("evalRules:", evalRules);

        setTestDetails((prev) => ({
          title: newData?.qdata.title ?? "",
          name: newData?.qdata.name ?? "",
          description: newData?.qdata?.description ?? "",
          answer: newData?.qdata.ansexp ?? "",
          ccTopic: newData?.secData?.id ?? "",
          ccLevel: newData?.secData?.complexityid ?? "",
          topicComplexity:
            buildTopicAndComplexity(
              JSON.parse(newData?.topicData),
              editTopics,
              editComplexity,
            ) ?? [],
          autoevaluate: newData?.qdata.autoevaluate ?? 0,
          duration: +newData?.qdata?.timelimit ?? "",
          marks: newData?.qdata?.marks ?? "",
          functionname: newData?.qdata?.functionname ?? "",
          returntype: newData?.cc?.returntype
            ? { value: newData?.cc?.returntype }
            : {},
          functionparams: buildFunctionParams(newData.cc) ?? [
            {
              id: nanoid(),
              parametername: "",
              parametertype: "",
              isdeletable: false,
            },
          ],
          testcases:
            buildTestCase(JSON.parse(newData?.io?.[0]?.testCases)) ?? [],
          supportedLanguage: newData.qcodes
            ? Object.values(newData.qcodes).map((lang) => ({
                id: lang.languageid,
                name: lang.langname,
                boilerplate: lang.boilerplateCode || "",
                solution: lang.solutionCode || "",
                executionCode: lang.executionCode || "",
                templateVersion: lang.templateVersion || 1,
                allTestCasesPassed: false,
              }))
            : [],
          evaluationrule:
            evalRules
              .filter((rule) => rule.value == newData?.cc?.evalrules)
              ?.map((rule) => rule.value) ?? [],
          testConfig: newData?.testDetails,
        }));
        setSelectedTopics(
          buildTopicAndComplexity(
            JSON.parse(newData?.topicData),
            editTopics,
            editComplexity,
          ),
        );
        setLanguageKeys(
          newData.qcodes
            ? Object.values(newData.qcodes).map((lang) => ({
                id: lang.languageid,
                name: lang.langname,
                boilerplate: lang.boilerplateCode || "",
                solution: lang.solutionCode || "",
                executionCode: lang.executionCode || "",
                allTestCasesPassed: false,
              }))
            : [],
        );
        setParameters(
          buildFunctionParams(newData.cc) ?? [
            {
              id: nanoid(),
              parametername: "",
              parametertype: "",
              isdeletable: false,
            },
          ],
        );
        setTestCases(
          buildTestCase(JSON.parse(newData?.io?.[0]?.testCases)) ?? [],
        );
        setSelectedCodingLanguages(
          Object.values(newData.qcodes).map((lang) => ({
            id: lang.languageid,
            name: lang.langname,
            boilerplate: lang.boilerplateCode || "",
            solution: lang.solutionCode || "",
            executionCode: lang.executionCode || "",
            allTestCasesPassed: false,
          })),
        );
      } catch (error) {
        useCommonFunctionHks.getCatchBlockDetails(error);
        // setQueLoading(true);
      } finally {
        setDataIsLoading(false);
      }
    };

    questionid && getQuestionDetails();
  }, [questionid]);

  console.log("errors:", errors);

  const buildTopicAndComplexity = (topicData, editTopics, editComplexity) => {
    return topicData.map(({ topicid, complexityid }) => {
      const topic = editTopics.find((t) => t.value === topicid);
      const complexity = editComplexity.find((c) => c.value === complexityid);

      return {
        id: nanoid(),
        topicId: topic?.value ?? null,
        topicName: topic?.label ?? "",
        complexityId: complexity?.value ?? null,
        complexityName: complexity?.label ?? "",
      };
    });
  };
  const buildFunctionParams = (cc) => {
    if (!cc?.inputvars || !cc?.datatypes) return undefined;

    const names = cc.inputvars.split(",");
    const types = cc.datatypes.split(",");

    return names.map((name, index) => ({
      id: nanoid(),
      parametername: name.trim() ?? "",
      parametertype: normalizeDataTypes(types[index]?.trim()) ?? "",
      isdeletable: true,
    }));
  };

  const normalizeDataTypes = (name) => {
    return name.toLowerCase();
  };

  const buildTestCase = (testcases) => {
    if (!testcases)
      return [
        {
          actualoutput: "",
          id: nanoid(),
          input: "",
          isExample: 0,
          output: "",
          isActive: true,
        },
      ];
    return testcases.map((tc) => ({
      ...tc,
      id: nanoid(),
      input: tc.input,
      output: tc.output,
    }));
  };

  // console.log("selectedTopic:", selectedTopics);

  const validateField = (step, name, value) => {
    let validator = validators[step]?.[name];
    if (name === "level" || name === "topics") {
      validator = validators[step]?.secName?.[name];
    }

    if (name === "parametername" || name === "parametertype") {
      validator = validators[1]?.functionparams?.[name];
    }
    // console.log("validator:", validator);

    if (!validator) return;
    if (name === "level" || name == "topics") {
      // console.log("setting error:");
      setErrors((prev) => ({
        ...prev,
        [step]: {
          ...prev[step],
          secName: {
            ...prev[step]?.secName,
            [name]: validator(value),
          },
        },
      }));
    } else if (name === "parametername" || name === "parametertype") {
      // console.log("setting error 2");
      setErrors((prev) => ({
        ...prev,
        1: {
          ...prev[1],
          functionparams: {
            ...prev.functionparams,
            [step]: {
              ...prev.functionparams?.[step],
              [name]: validator(value),
            },
          },
        },
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        [step]: {
          ...prev[step],
          [name]: validator(value),
        },
      }));
      // console.log("validator(value):", validator(value));
    }
  };

  const onChangeDetailFields = (step, field, value) => {
    if (field === "libTypeId") {
      setLibTypeId(value);
    } else if (field === "topics" || field === "level") {
      // console.log("setting value..");
      setTestDetails((prev) => ({
        ...prev,
        secName: prev.secName.map((item, idx) =>
          idx === 0 ? { ...item, [field]: value } : item,
        ),
      }));
    } else if (field === "parametername" || field === "parametertype") {
      setParameters((prev) => {
        const updated = prev.map((p) =>
          p.id === step ? { ...p, [field]: value } : p,
        );
        const next = updated.map((p) => {
          if (p.id === step && p.parametername && p.parametertype) {
            return {
              ...p,
              isdeletable: true,
            };
          }
          return p;
        });
        setTestDetails((td) => ({
          ...td,
          functionparams: next,
        }));

        return next;
      });
    } else if (field === "returntype") {
      setTestDetails((prev) => ({
        ...prev,
        [field]: { ...prev[field], value: value },
      }));
    } else if (field === "evalutionrule") {
      setTestDetails((prev) => ({
        ...prev,
        evaluationrule: value,
      }));
    } else setTestDetails((prev) => ({ ...prev, [field]: value }));
    validateField(step, field, value);
  };
  // console.log("validationRUles:", validationRules);

  const validateFieldTestCases = (
    testcaseIndex,
    parameterIndex,
    field,
    value,
  ) => {
    let validator;
    if (field === "input" || field === "output") {
      validator = validators[1]?.testcases?.[field];
    }
    // console.log("validator:", validator);

    if (!validator) return;
    if (field === "input") {
      // onChange validate function - FIXED
      // Then validate
      setErrors((prev) => ({
        ...prev,
        1: {
          ...prev[1],
          testcases: {
            ...prev[1]?.testcases,
            [testcaseIndex]: {
              ...prev[1]?.testcases?.[testcaseIndex],
              [field]:
                field === "input"
                  ? (() => {
                      const prevArr =
                        prev[1]?.testcases?.[testcaseIndex]?.input ??
                        Array(parameters.length).fill(null);
                      const nextArr = [...prevArr];

                      // Validate the specific parameter
                      const trimmedValue = value?.trim();
                      nextArr[parameterIndex] =
                        !trimmedValue || trimmedValue.length === 0
                          ? "Input is required"
                          : null;

                      // Return null if all errors are null, otherwise return the array
                      return nextArr.every((e) => e === null) ? null : nextArr;
                    })()
                  : validator(value),
            },
          },
        },
      }));
    } else if (field === "output") {
      setErrors((prev) => ({
        ...prev,
        1: {
          ...prev[1],
          testcases: {
            ...prev[1].testcases,
            [testcaseIndex]: {
              ...prev[1].testcases?.[testcaseIndex],
              [field]: validator(value),
            },
          },
        },
      }));
    }
  };
  const onChangeTestCases = (testcaseIndex, parameterIndex, field, value) => {
    if (field === "input") {
      setTestDetails((td) => ({
        ...td,
        testcases: td.testcases.map((tc, i) => {
          if (i !== testcaseIndex) return tc;

          // convert string to array
          const inputArr =
            typeof tc.input === "string" && tc.input.length > 0
              ? tc.input.split("\n")
              : [];

          inputArr[parameterIndex] = value;

          return {
            ...tc,
            input: inputArr.join("\n"),
          };
        }),
      }));

      setTestCases((prev) =>
        prev.map((tc, i) => {
          if (i !== testcaseIndex) return tc;

          const inputArr =
            typeof tc.input === "string" && tc.input.length > 0
              ? tc.input.split("\n")
              : [];

          inputArr[parameterIndex] = value;

          return {
            ...tc,
            input: inputArr.join("\n"),
          };
        }),
      );
    } else if (field === "output") {
      setTestDetails((td) => ({
        ...td,
        testcases: td.testcases.map((tc, i) =>
          i === testcaseIndex ? { ...tc, [field]: value } : tc,
        ),
      }));
      setTestCases((prev) =>
        prev.map((tc, i) =>
          i === testcaseIndex ? { ...tc, output: value } : tc,
        ),
      );
    } else if (field === "isExample") {
      setTestDetails((td) => ({
        ...td,
        testcases: td.testcases.map((tc, i) =>
          i === testcaseIndex ? { ...tc, [field]: value } : tc,
        ),
      }));
      setTestCases((prev) =>
        prev.map((tc, i) =>
          i === testcaseIndex ? { ...tc, [field]: value } : tc,
        ),
      );
    }
    validateFieldTestCases(testcaseIndex, parameterIndex, field, value);
  };

  const handleReturnChange = (value) => {
    // setCurrentType({ value: value });
    setTestDetails((prev) => ({
      ...prev,
      returntype: { value: value },
    }));
  };

  const breadcrumbItems = [
    { label: "Library" },
    {
      label: `Coding Challenge`,
      href: `/library/${type}/questionlist`,
    },
    { label: `${questionid ? "Edit" : "Add"} Question` },
  ];

  const steps = useMemo(() => {
    let baseSteps = [
      {
        id: 1,
        label: "Question Details",
        component: (
          <QuestionForm
            testDetails={testDetails}
            setTestDetails={setTestDetails}
            errors={errors[0]}
            setErrors={setErrors}
            onChange={onChangeDetailFields}
            isPublished={isPublished}
            level={level}
            ccTopic={ccTopic}
            topics={topics}
            selectedTopics={selectedTopics}
            setSelectedTopics={setSelectedTopics}
          />
        ),
      },
      {
        id: 2,
        label: "Configuration",
        component: (
          <QuestionConfiguration
            testDetails={testDetails}
            setTestDetails={setTestDetails}
            onChange={onChangeDetailFields}
            onChangeTestCases={onChangeTestCases}
            errors={errors[1]}
            setErrors={setErrors}
            topicErrors={topicErrors}
            isPublished={isPublished}
            types={returnTypes}
            currentType={currentType}
            handleReturnChange={handleReturnChange}
            parameters={parameters}
            setParameters={setParameters}
            testcases={testcases}
            setTestCases={setTestCases}
            value={value}
            setValue={setValue}
          />
        ),
      },
      {
        id: 3,
        label: "Validation",
        component: (
          <QuestionValidation
            languages={languages}
            setLanguages={setLanguages}
            selectedLanguage={selectedLaguage}
            setSelectedLanguage={setSelectedLanguage}
            validationRules={validationRules}
            setValidationRules={setValidationRules}
            onChange={onChangeDetailFields}
            errors={errors[2]}
            setErrors={setErrors}
            // topicErrors={topicErrors}
            testDetails={testDetails}
            setTestDetails={setTestDetails}
            selectedCodingLanguages={selectedCodingLanguages}
            setSelectedCodingLanguages={setSelectedCodingLanguages}
            languagesOfPassedTestCases={languagesOfPassedTestCases}
            setLanguagesOfPassedTestCases={setLanguagesOfPassedTestCases}
            fromEditQuestion={fromEditQuestion}
            languageKeys={languageKeys}
            parameters={parameters}
            dataIsLoading={dataIsLoading}
            setDataIsLoading={setDataIsLoading}
          />
        ),
      },
    ];
    return baseSteps;
  }, [
    libTypeId,
    errors,
    testDetails,
    topicErrors,
    isPublished,
    level,
    ccTopic,
    topics,
    selectedTopics,
    currentType,
    parameters,
    value,
    testcases,
    languages,
    validationRules,
    selectedLaguage,
    selectedCodingLanguages,
    languagesOfPassedTestCases,
    dataIsLoading,
  ]);

  const hasAnyError = (obj) => {
    if (!obj) return false;

    if (typeof obj === "string") {
      return obj.trim().length > 0;
    }

    if (Array.isArray(obj)) {
      return obj.some(hasAnyError);
    }

    if (typeof obj === "object") {
      return Object.values(obj).some(hasAnyError);
    }

    return false;
  };

  function normalizeInputString(input = "", paramCount) {
    let values = typeof input === "string" ? input.split("\n") : [];
    while (values.length < paramCount) {
      values.push("");
    }
    values = values.slice(0, paramCount);
    return values.join("\n");
  }

  const validateStep = (step) => {
    let stepErrors = {};
    let hasConfigError = false;
    let copyTestDetails = structuredClone(testDetails);

    if (step === 0) {
      //
      Object.entries(validators[step]).forEach(([field, rule]) => {
        console.log("rule", rule);
        if (field === "secName") {
          if (selectedTopics.length === 0) {
            Object.entries(rule).forEach(([nestedField, nestedRule]) => {
              stepErrors.secName ??= {};
              stepErrors.secName[nestedField] = `${nestedField} is required`;
            });
          }
        } else if (field === "ccSecName") {
          Object.entries(rule).forEach(([nestedField, nestedRule]) => {
            console.log(
              "nestedField:",
              nestedField,
              "nestedRule:",
              nestedRule,
              "testDetails.ccLevel:",
              testDetails.ccLevel,
              "testDetails.ccTopic:",
              testDetails.ccTopic,
            );

            if (testDetails.ccLevel || testDetails.ccTopic) {
              stepErrors.ccSecName ??= {};
              stepErrors.ccSecName[nestedField] = nestedRule(
                testDetails[nestedField],
              );
            }
          });
        } else {
          const error =
            field === "libTypeId" ? rule(libTypeId) : rule(testDetails[field]);
          if (error) stepErrors[field] = error;
        }
      });
    } else if (step === 1) {
      setTestCases((prev) =>
        prev.map((tc) => ({
          ...tc,
          input: normalizeInputString(tc.input, parameters.length),
        })),
      );
      setTestDetails((prev) => ({
        ...prev,
        testcases: prev.testcases.map((tc) => ({
          ...tc,
          input: normalizeInputString(tc.input, parameters.length),
        })),
      }));
      Object.entries(validators[step]).forEach(([field, rule]) => {
        if (field === "functionparams") {
          parameters.forEach((para) => {
            Object.entries(rule).forEach(([nestedField, nestedRule]) => {
              stepErrors.functionparams ??= {};
              stepErrors.functionparams[para.id] ??= {};

              stepErrors.functionparams[para.id][nestedField] = nestedRule(
                para[nestedField],
              );
            });
          });
        } else if (field === "testcases") {
          testcases.forEach((testcase, index) => {
            console.log("testcase:", testcase);
            Object.entries(rule).forEach(([nestedField, nestedRule]) => {
              stepErrors.testcases ??= {};
              stepErrors.testcases[index] ??= {};
              console.log("nestedfield:", nestedField, "testcase", testcase);
              stepErrors.testcases[index][nestedField] =
                nestedField === "input"
                  ? nestedRule(testcase.input, parameters.length)
                  : nestedRule(testcase[nestedField]);
            });
          });
        } else {
          const error =
            field === "returntype"
              ? rule(testDetails[field].value)
              : rule(testDetails[field]);
          if (error) stepErrors[field] = error;
        }
      });
      let minThreeExample = testDetails?.testcases?.filter(
        (ts) => ts.isExample == 1,
      );
      stepErrors.minExample ??= {};
      if (minThreeExample.length > 3) {
        stepErrors.minExample["minExample"] = "Three examples are enough.";
      }
      if (minThreeExample.length < 3) {
        stepErrors.minExample["minExample"] =
          "Atleast three examples are required.";
      }

      const role = getDataFromStorage("role");
      const canUpdate =
        role === constants.Roles.admin ||
        role === constants.Roles.creator ||
        role === constants.Roles.super_admin ||
        role === constants.Roles.trainer;

      if (!canUpdate) {
        setIsButtonDisable(true);
      }
    }

    if (step === 2) {
      let solutionCodeIsThere = selectedCodingLanguages.filter(
        (lang) => lang?.passed,
      );
      // console.log("solutionCODEEE:", solutionCodeIsThere);
      if (solutionCodeIsThere.length === 0) {
        // console.log("solution code is not there..");
        stepErrors["solutionCode"] ??= {};
        stepErrors["solutionCode"] = "Test the solution code before saving";
      } else {
        return true;
      }
    }

    setErrors((prev) => ({ ...prev, [step]: stepErrors }));
    if (hasConfigError) {
      setTestDetails(copyTestDetails);
    }
    console.log("stepErros:", stepErrors);

    const isValid = !hasAnyError(stepErrors);
    return isValid;
  };

  const addQuestion = async (status) => {
    console.log("status:", status, questionid);

    setDataIsLoading(true);

    // let countHiddenTestCases = 0;
    // let countStudentTestCases = 0;
    // for (let i = 0; i < testDetails.testcases.length; i++) {
    //   if (
    //     testDetails.testcases[i].isExample == 0 ||
    //     testDetails.testcases[i].isExample == false
    //   ) {
    //     countHiddenTestCases = countHiddenTestCases + 1;
    //   } else {
    //     countStudentTestCases = countStudentTestCases + 1;
    //   }
    // }

    // if (countHiddenTestCases < 3) {
    //   Alert.setShowNotify({
    //     show: true,
    //     msg: "TestCases are Not Enough Make Sure add Atleast 3",
    //     title: "Warning !",
    //   });
    //   return;
    // } else if (countHiddenTestCases > 5) {
    //   Alert.setShowNotify({
    //     show: true,
    //     msg: "TestCases added More than  Enough Make Sure add AtMax 5",
    //     title: "Warning !",
    //   });
    //   return;
    // }

    let questionsData;
    let form = new FormData(),
      isProceed = false;

    let temp = testDetails.evaluationrule.map((data) => data);

    LibraryCxt.setUserInp({
      evalrules: temp.join(),
      ...LibraryCxt.userInput,
      functionname: testDetails.functionname,
    });

    qcodes = testDetails.supportedLanguage;

    // if (testDetails?.testcases.length === 0) {
    //   setTestDetails((prev) => ({
    //     ...prev,
    //     [testcases]: Props.selectque.io,
    //   }));
    // }

    let newObj = testDetails;
    newObj.topicData = selectedTopics;
    newObj.secName = {
      id: newObj.ccTopic,
      level: newObj.ccLevel,
    };
    if (questionid) {
      newObj.questionid = questionid;
    }

    console.log("newObj:", newObj);

    questionsData = JSON.stringify({
      io: testDetails?.testcases,
      qcodes: qcodes,
      qdata: newObj,
      isNoTestCases: false,
    });

    if (embedLinksList.length > 0) {
      form.append("embedLinks", embedLinksList);
    }

    if (questionid && testDetails.testConfig.length > 0) {
      form.append(
        "testConfigIds",
        testDetails?.testConfig
          .map((testData) => testData.testconfigid)
          .toString(),
      );
    }

    form.append("qdata", questionsData);
    form.append("libtypeid", type);
    form.append("libtypename", "Coding Challenge");
    isProceed = true;

    if (isProceed) {
      let urls =
        status === "add"
          ? "node/admin/library/add"
          : status === "update"
          ? "node/admin/library/update"
          : null;
      axios({
        url: urls,
        data: form,
        method: "post",
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          setDataIsLoading(false);

          if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
            if (Alert.fromList.isFromList) {
              Alert.setFromList({ isFromList: false, libType: "" });

              let newDetails = { ...Alert.lpData2 },
                uniqueId = 1,
                libraryData = {
                  isNew: true,
                  published: 0,
                  isEdited: false,
                  id: res.data.data.libid,
                  libTypeId: Alert.lpData2.libTypeId,
                  title: LibraryCxt.userInput.name,
                  topics: [
                    {
                      topicid: LibraryCxt.userInput.topic,
                    },
                  ],
                };

              if (Alert.isOldLpDetail) libraryData.status = "new";

              for (let i = 0; i < newDetails.modules.length; i++) {
                if (newDetails.modules[i].id === newDetails.moduleId)
                  newDetails.modules[i].moduleData.push(libraryData);

                for (
                  let j = 0;
                  j < newDetails.modules[i].moduleData.length;
                  j++
                ) {
                  newDetails.modules[i].moduleData[j].moduleDataId = uniqueId;
                  newDetails.modules[i].moduleData[j].key = nanoid();
                  uniqueId++;
                }

                newDetails.modules[i].id = uniqueId;
                uniqueId++;
              }

              newDetails.isAddTest = false;
              Alert.handleNavigateToLpAfterAddTest(newDetails);
            } else if (Alert.isOldLpDetail) {
              let newDetails = JSON.parse(JSON.stringify(Alert.lpData2));

              for (let i = 0; i < newDetails.modules.length; i++) {
                if (newDetails.modules[i].id === newDetails.moduleId) {
                  for (
                    let j = 0;
                    j < newDetails.modules[i].moduleData.length;
                    j++
                  ) {
                    if (
                      newDetails.modules[i].moduleData[j] &&
                      LibraryCxt.userInput.id ===
                        newDetails.modules[i].moduleData[j].libId
                    ) {
                      newDetails.modules[i].moduleData[j].libId =
                        res.data.data.libid;
                      newDetails.modules[i].moduleData[j].title =
                        LibraryCxt.userInput.name;
                      newDetails.modules[i].moduleData[j].testDuration =
                        LibraryCxt.userInput.maxtime;
                      newDetails.modules[i].moduleData[j].moved = "yes";
                    }
                  }
                }
              }

              Alert.setLpData2(newDetails);

              return (async () => {
                try {
                  let res = await handleAddOrUpdateLp({}, newDetails.modules);

                  if (res.title === "success") {
                    Alert.setShowNotify({
                      show: true,
                      msg: res.message,
                      title: "Success !",
                    });
                    Alert.handleNavigateToLpAfterAddTest(newDetails);
                  }
                } catch (err) {
                  Alert.setIsUnAuth(err.hasOwnProperty("isUnAuth"));
                  const isUnAuth = err.message.includes("403");
                  setShowNotify({
                    show: true,
                    msg: isUnAuth
                      ? "Encountered an error while fetching coding challenge sections"
                      : "You have been logged-out due to inactivity. Login again.",
                    title: isUnAuth ? "Warning" : "Error",
                    isUnAuth,
                  });
                }
              })();
            } else {
              Alert.setResultCode(res.data.resultCode);
              Alert.setShowNotify({
                show: true,
                msg: (
                  <>
                    {res.data.message} <br />
                  </>
                ),
                title: "Success",
              });
            }
            navigate("/library/5/questionlist");
          } else {
            Alert.setShowNotify({
              show: true,
              msg: res.data.message,
              title: "Error",
            });
          }
        })
        .catch((error) => {
          setDataIsLoading(false);
          if (status === "update") {
            Alert.setIsUnAuth(error.hasOwnProperty("isUnAuth"));
            const isUnAuth = error.message.includes("403");
            Alert.setShowNotify({
              show: true,
              msg: !isUnAuth
                ? "Encountered an error while update the question"
                : "You have been logged-out due to inactivity. Login again.",
              title: isUnAuth ? "Warning" : "Error",
              isUnAuth,
            });
          } else useCommonFunctionHks.getCatchBlockDetails(error);
        })
        .finally(() => {
          setDataIsLoading(false);
        });
    }
  };

  const onNextOrFinish = async () => {
    // console.log("active Step;", activeStep);

    let isValid = validateStep(activeStep);
    // console.log("isValid:", isValid);

    if (isValid && activeStep === 2) {
      const role = getDataFromStorage("role");
      const canUpdate =
        role === constants.Roles.admin ||
        role === constants.Roles.creator ||
        role === constants.Roles.super_admin ||
        role === constants.Roles.trainer;
      if (questionid && canUpdate) {
        addQuestion("update");
      } else {
        addQuestion("add");
      }
    } else if (!isValid) {
      setOpenToast(true);
      setErrMsg("Please fill the highlighted fields.");
      return isValid;
    } else {
      return isValid;
    }
  };

  const fetchQuestionComplexity = async () => {
    try {
      const response = await axios.get(
        "node/admin/complexity/get",
        useCommonFunctionHks.getHeaderDetailsForAxios(),
      );
      let newcomplexity = response?.data.map((comp) => {
        return {
          value: comp.id,
          label: comp.name,
        };
      });
      setLevel(newcomplexity);
      LibraryCxt.setComplexities(newcomplexity);
    } catch (error) {
      const isUnAuth = error.message.includes("403");
      setShowNotify({
        show: true,
        msg: isUnAuth
          ? "Encountered an error while fetching coding challenge sections"
          : "You have been logged-out due to inactivity. Login again.",
        title: isUnAuth ? "Warning" : "Error",
        isUnAuth,
      });
      useCommonFunctionHks.getCatchBlockDetails(error);
    }
  };
  const fetchQuestionCCTopic = async () => {
    try {
      const response = await axios.get(
        `node/learner/cc/section?isSOADashboard=${false}`,
        useCommonFunctionHks.getHeaderDetailsForAxios(),
      );
      if (response?.data?.resultCode === constants.RESULT_STATUS.SUCCESS) {
        const data = response.data?.data?.map((item) => ({
          label: item.name,
          id: item.id,
          value: item.id,
        }));
        setCcTopic(data);
      }
    } catch (error) {
      const isUnAuth = error.message.includes("403");
      setShowNotify({
        show: true,
        msg: isUnAuth
          ? "Encountered an error while fetching coding challenge sections"
          : "You have been logged-out due to inactivity. Login again.",
        title: isUnAuth ? "Warning" : "Error",
        isUnAuth,
      });
      useCommonFunctionHks.getCatchBlockDetails(error);
    }
  };
  const fetchQuestionTopic = async () => {
    try {
      const { data } = await axios.get(
        `node/admin/topic/get/${0}`,
        useCommonFunctionHks.getHeaderDetailsForAxios(),
      );
      if (data.resultCode === RESULT_STATUS.SUCCESS) {
        let topicsFormat = data?.data.map((top) => {
          return {
            value: top.id,
            label: top.name,
          };
        });
        setTopics(topicsFormat);
        LibraryCxt.setTopics(topicsFormat);
      }
    } catch (error) {
      const isUnAuth = error.message.includes("403");
      setShowNotify({
        show: true,
        msg: isUnAuth
          ? "Encountered an error while fetching coding challenge sections"
          : "You have been logged-out due to inactivity. Login again.",
        title: isUnAuth ? "Warning" : "Error",
        isUnAuth,
      });
      useCommonFunctionHks.getCatchBlockDetails(error);
    }
  };

  useEffect(() => {
    fetchQuestionComplexity();
    fetchQuestionCCTopic();
    fetchQuestionTopic();
  }, []);

  console.log("testDetails:", testDetails);

  return (
    <div className="cc-question-creation-main-container">
      {dataIsLoading && <Loading />}
      <Toast
        open={openToast}
        onClose={() => setOpenToast(false)}
        message={errMsg}
        type={toastType}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        // slots={{ transition: Slide }}
      />
      <section className="create-question-section-1">
        <ReusableBreadcrumbs items={breadcrumbItems} />
      </section>
      <section className="create-question-main-section-container">
        {/* <h1 className="create-question-section-title">{`${
          questionid ? "Edit" : "Add"
        } Coding Challenge Question`}</h1> */}
        <Banner
          text={
            <>
              Note: The code execution process has been updated. Please find the{" "}
              <span className="banner-highlight">Solution template</span> to
              execute your code in solution. If the template is not available,
              click <span className="banner-highlight">Generate</span> to create
              it.
            </>
          }
        />
        <Stepper
          steps={steps}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          onNext={onNextOrFinish}
          onFinish={onNextOrFinish}
          nextButtonDisable={isButtonDisable}
          className="create-question-stepper"
        />
      </section>
      {/* <Modal
        centered
        showCloseIcon={true}
        isOpen={showPopupForm}
        onClose={() => {
          setShowPopupForm(false);
        }}
        title={"Coding Challenge Modification"}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "25px" }}>
          <div>{`Do you want to update ${!JSON.parse(isFixedQns) ? " or save as a new " : ""
            } question?`}</div>
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              alignSelf: "end",
            }}
          >
            {(getDataFromStorage("role") === constants.Roles.admin ||
              getDataFromStorage("role") === constants.Roles.creator ||
              getDataFromStorage("role") === constants.Roles.super_admin ||
              getDataFromStorage("role") === constants.Roles.trainer) &&
              questionid && (
                <Button
                  size="sm"
                  hierarchy={{
                    type: "secondaryGrey",
                    buttonText: "Update",
                  }}
                  onClick={(e) => addQuestion("update")}
                />
              )}
            {!JSON.parse(isFixedQns) && (
              <Button
                size="sm"
                hierarchy={{
                  type: "primary",
                  buttonText: questionid ? "Save as new" : "Save",
                }}
                onClick={(e) => addQuestion("add")}
              />
            )}
          </div>
        </div>
      </Modal> */}
    </div>
  );
};

export default CodingQuestionEntry;
